webpackJsonp([2],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _preact = __webpack_require__(1);
	
	var _embedContainer = __webpack_require__(24);
	
	var _embedContainer2 = _interopRequireDefault(_embedContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _preact.render)((0, _preact.h)(_embedContainer2.default, null), document.getElementById('app'));
	
	__webpack_require__(33);

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var Countdown = function Countdown(_ref) {
	  var noLine = _ref.noLine,
	      alignment = _ref.alignment,
	      _ref$timeLeft = _ref.timeLeft,
	      timeLeft = _ref$timeLeft === undefined ? '--' : _ref$timeLeft;
	
	  var klass = 'countdown';
	  var timeLeftIsNumber = typeof timeLeft === 'number' && isFinite(timeLeft);
	
	  if (alignment === 'center') {
	    klass += ' countdown--center';
	  }
	
	  if (noLine) {
	    klass += ' countdown--noline';
	  }
	
	  var output = null;
	
	  if (timeLeft === '--') {
	    output = 'Next update in ' + timeLeft;
	  } else if (timeLeftIsNumber) {
	    output = 'Next update in :' + timeLeft;
	  } else if (timeLeft === 'Updating!') {
	    output = timeLeft;
	  }
	  return (0, _preact.h)(
	    'div',
	    { className: klass },
	    output
	  );
	};
	
	exports.default = Countdown;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _formatPercent = __webpack_require__(9);
	
	var _formatPercent2 = _interopRequireDefault(_formatPercent);
	
	var _numberWithCommas = __webpack_require__(2);
	
	var _numberWithCommas2 = _interopRequireDefault(_numberWithCommas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Candidate = function Candidate(_ref) {
	  var candidate = _ref.candidate,
	      raceCalled = _ref.raceCalled,
	      raceUncontested = _ref.raceUncontested,
	      totalVotes = _ref.totalVotes;
	
	  var pill = 'pill-circle pill--' + candidate.party.slice(0, 3);
	  var rowClass = 'candidate race__candidate-row' + (raceCalled && candidate.winner ? ' race__candidate-row--winner' : '');
	
	  return (0, _preact.h)(
	    'tr',
	    { className: rowClass },
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__party' },
	      (0, _preact.h)(
	        'span',
	        { className: pill },
	        candidate.party.slice(0, 1).toUpperCase()
	      )
	    ),
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__name' },
	      raceCalled && candidate.winner && '\u2713 ',
	      candidate.ballot_name,
	      ' ',
	      candidate.incumbent && (0, _preact.h)(
	        'span',
	        { 'class': 'pill pill--basic' },
	        'Incumbent'
	      )
	    ),
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__votes' },
	      raceUncontested ? '-' : (0, _numberWithCommas2.default)(candidate.votes)
	    ),
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__pct' },
	      raceUncontested ? '-' : (0, _formatPercent2.default)(candidate.votes, totalVotes),
	      (0, _preact.h)(
	        'span',
	        { className: 'candidate__pct-symbol' },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = Candidate;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _candidate = __webpack_require__(5);
	
	var _candidate2 = _interopRequireDefault(_candidate);
	
	var _countdown = __webpack_require__(4);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _mergeWriteIns = __webpack_require__(7);
	
	var _mergeWriteIns2 = _interopRequireDefault(_mergeWriteIns);
	
	var _numberWithCommas = __webpack_require__(2);
	
	var _numberWithCommas2 = _interopRequireDefault(_numberWithCommas);
	
	var _sortCandidates = __webpack_require__(10);
	
	var _sortCandidates2 = _interopRequireDefault(_sortCandidates);
	
	var _sumValues = __webpack_require__(3);
	
	var _sumValues2 = _interopRequireDefault(_sumValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Race = function (_Component) {
	  _inherits(Race, _Component);
	
	  function Race() {
	    _classCallCheck(this, Race);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Race.prototype.render = function render() {
	    var race = this.props.race;
	
	    if (!race) return null;
	
	    var isPresident = race.office_slug === 'us-president';
	    var isScoreboard = this.props.scoreboard;
	    var isOnHomepage = this.props.isOnHomepage;
	
	    var candidates = isPresident ? (0, _mergeWriteIns2.default)(race.candidates) : race.candidates;
	    var totalVotes = (0, _sumValues2.default)(candidates, 'votes');
	
	    var candidatesOutput = (0, _sortCandidates2.default)(candidates).map(function (candidate) {
	      return (0, _preact.h)(_candidate2.default, { raceCalled: race.called, raceUncontested: race.uncontested, totalVotes: totalVotes, candidate: candidate });
	    });
	
	    var precincts = (0, _numberWithCommas2.default)(race.precincts_reporting) + ' of ' + (0, _numberWithCommas2.default)(race.total_precincts) + ' precincts reporting (' + race.precincts_reporting_percent.toFixed(1) + '%)';
	
	    var countdown = null;
	
	    if (this.props.timeLeft) {
	      countdown = (0, _preact.h)(_countdown2.default, { timeLeft: this.props.timeLeft });
	    }
	
	    return (0, _preact.h)(
	      'div',
	      { className: 'widget' },
	      (0, _preact.h)(
	        'div',
	        { className: 'race' },
	        countdown,
	        (0, _preact.h)(
	          'table',
	          { className: 'race__candidates' },
	          (0, _preact.h)(
	            'caption',
	            null,
	            (0, _preact.h)(
	              'div',
	              { className: 'race__caption' },
	              (0, _preact.h)(
	                'p',
	                { className: 'race__title' },
	                !isOnHomepage && race.office + ' — ' + race.district_display
	              ),
	              isScoreboard && false && (0, _preact.h)(
	                'label',
	                { 'class': 'race__save' },
	                (0, _preact.h)('input', { 'class': 'race__save-input', type: 'checkbox', value: race.id }),
	                'Save race'
	              )
	            )
	          ),
	          (0, _preact.h)(
	            'thead',
	            null,
	            (0, _preact.h)(
	              'tr',
	              null,
	              (0, _preact.h)(
	                'th',
	                { className: 'race__candidate-header', colspan: '2' },
	                isOnHomepage && 'Presidential',
	                ' Candidate'
	              ),
	              (0, _preact.h)(
	                'th',
	                { className: 'race__candidate-header race__candidate-header--numeric' },
	                isPresident ? 'Votes in Texas' : 'Votes'
	              ),
	              (0, _preact.h)(
	                'th',
	                { className: 'race__candidate-header race__candidate-header--numeric' },
	                'Pct.',
	                (0, _preact.h)(
	                  'span',
	                  { className: 'candidate__pct-symbol' },
	                  '%'
	                )
	              )
	            )
	          ),
	          (0, _preact.h)(
	            'tbody',
	            null,
	            race.called && race.result !== 'not called' && (0, _preact.h)(
	              'tr',
	              { 'class': 'race__called-row' },
	              (0, _preact.h)(
	                'td',
	                { colspan: '4' },
	                race.result === 'uncontested' ? null : 'Projected',
	                ' ',
	                isPresident ? 'Texas ' + race.result : race.result
	              )
	            ),
	            candidatesOutput
	          )
	        ),
	        (0, _preact.h)(
	          'div',
	          { className: 'race__metrics' },
	          this.props.includeFullResultsButton ? (0, _preact.h)(
	            'a',
	            { className: 'button button--yellow', href: 'https://elections.texastribune.org/2016/general-election-results/' },
	            'View full election results \xBB'
	          ) : (0, _preact.h)('span', null),
	          (0, _preact.h)(
	            'p',
	            { className: 'race__precincts' },
	            race.uncontested ? 'No totals reported in uncontested races' : precincts
	          )
	        )
	      )
	    );
	  };
	
	  return Race;
	}(_preact.Component);
	
	exports.default = Race;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mergeWriteIns;
	
	var _sumValues = __webpack_require__(3);
	
	var _sumValues2 = _interopRequireDefault(_sumValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mergeWriteIns(candidates) {
	  var writeIns = candidates.filter(function (candidate) {
	    return candidate.party === 'writein';
	  });
	  var writeInsTotalVotes = (0, _sumValues2.default)(writeIns, 'votes');
	  var merged = candidates.filter(function (candidate) {
	    return candidate.party !== 'writein';
	  });
	
	  merged.push({
	    id: 9999,
	    ballot_name: 'Write-in candidates',
	    ballot_last_name: 'Write-ins',
	    incumbent: false,
	    winner: false,
	    votes: writeInsTotalVotes,
	    party: 'writein'
	  });
	
	  return merged;
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! pym.js - v1.1.1 - 2016-10-01 */
	/*
	* Pym.js is library that resizes an iframe based on the width of the parent and the resulting height of the child.
	* Check out the docs at http://blog.apps.npr.org/pym.js/ or the readme at README.md for usage.
	*/
	
	/** @module pym */
	(function(factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module !== 'undefined' && module.exports) {
	        module.exports = factory();
	    } else {
	        window.pym = factory.call(this);
	    }
	})(function() {
	    var MESSAGE_DELIMITER = 'xPYMx';
	
	    var lib = {};
	
	    /**
	    * Generic function for parsing URL params.
	    * Via http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
	    *
	    * @method _getParameterByName
	    * @inner
	    *
	    * @param {String} name The name of the paramter to get from the URL.
	    */
	    var _getParameterByName = function(name) {
	        var regex = new RegExp("[\\?&]" + name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]') + '=([^&#]*)');
	        var results = regex.exec(location.search);
	
	        if (results === null) {
	            return '';
	        }
	
	        return decodeURIComponent(results[1].replace(/\+/g, " "));
	    };
	
	    /**
	     * Check the message to make sure it comes from an acceptable xdomain.
	     * Defaults to '*' but can be overriden in config.
	     *
	     * @method _isSafeMessage
	     * @inner
	     *
	     * @param {Event} e The message event.
	     * @param {Object} settings Configuration.
	     */
	    var _isSafeMessage = function(e, settings) {
	        if (settings.xdomain !== '*') {
	            // If origin doesn't match our xdomain, return.
	            if (!e.origin.match(new RegExp(settings.xdomain + '$'))) { return; }
	        }
	
	        return true;
	    };
	
	    /**
	     * Construct a message to send between frames.
	     *
	     * NB: We use string-building here because JSON message passing is
	     * not supported in all browsers.
	     *
	     * @method _makeMessage
	     * @inner
	     *
	     * @param {String} id The unique id of the message recipient.
	     * @param {String} messageType The type of message to send.
	     * @param {String} message The message to send.
	     */
	    var _makeMessage = function(id, messageType, message) {
	        var bits = ['pym', id, messageType, message];
	
	        return bits.join(MESSAGE_DELIMITER);
	    };
	
	    /**
	     * Construct a regex to validate and parse messages.
	     *
	     * @method _makeMessageRegex
	     * @inner
	     *
	     * @param {String} id The unique id of the message recipient.
	     */
	    var _makeMessageRegex = function(id) {
	        var bits = ['pym', id, '(\\S+)', '(.*)'];
	
	        return new RegExp('^' + bits.join(MESSAGE_DELIMITER) + '$');
	    };
	
	    /**
	     * Clean autoInit Instances: those that point to contentless iframes
	     * @method _cleanAutoInitInstances
	     * @inner
	     */
	    var _cleanAutoInitInstances = function() {
	        var length = lib.autoInitInstances.length;
	
	        // Loop backwards to avoid index issues
	        for (var idx = length - 1; idx >= 0; idx--) {
	            var instance = lib.autoInitInstances[idx];
	            // If instance has been removed or is contentless then remove it
	            if (instance.el.getElementsByTagName('iframe').length &&
	                instance.el.getElementsByTagName('iframe')[0].contentWindow) {
	                continue;
	            }
	            else {
	                // Remove the reference to the removed or orphan instance
	                lib.autoInitInstances.splice(idx,1);
	            }
	        }
	    };
	
	    /**
	     * Store auto initialized Pym instances for further reference
	     * @name module:pym#autoInitInstances
	     * @type Array
	     * @default []
	     */
	    lib.autoInitInstances = [];
	
	    /**
	     * Initialize Pym for elements on page that have data-pym attributes.
	     * Expose autoinit in case we need to call it from the outside
	     * @instance
	     * @method autoInit
	     */
	    lib.autoInit = function() {
	        var elements = document.querySelectorAll('[data-pym-src]:not([data-pym-auto-initialized])');
	        var length = elements.length;
	
	        // Clean stored instances in case needed
	        _cleanAutoInitInstances();
	        for (var idx = 0; idx < length; ++idx) {
	            var element = elements[idx];
	            /*
	            * Mark automatically-initialized elements so they are not
	            * re-initialized if the user includes pym.js more than once in the
	            * same document.
	            */
	            element.setAttribute('data-pym-auto-initialized', '');
	
	            // Ensure elements have an id
	            if (element.id === '') {
	                element.id = 'pym-' + idx;
	            }
	
	            var src = element.getAttribute('data-pym-src');
	
	            // List of data attributes to configure the component
	            // structure: {'attribute name': 'type'}
	            var settings = {'xdomain': 'string', 'title': 'string', 'name': 'string', 'id': 'string',
	                              'sandbox': 'string', 'allowfullscreen': 'boolean'};
	
	            var config = {};
	
	            for (var attribute in settings) {
	                // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute#Notes
	               if (element.getAttribute('data-pym-'+attribute) !== null) {
	                  switch (settings[attribute]) {
	                    case 'boolean':
	                       config[attribute] = !(element.getAttribute('data-pym-'+attribute) === 'false'); // jshint ignore:line
	                       break;
	                    case 'string':
	                       config[attribute] = element.getAttribute('data-pym-'+attribute);
	                       break;
	                    default:
	                       console.err('unrecognized attribute type');
	                  }
	               }
	            }
	
	            // Store references to autoinitialized pym instances
	            var parent = new lib.Parent(element.id, src, config);
	            lib.autoInitInstances.push(parent);
	        }
	
	        // Return stored autoinitalized pym instances
	        return lib.autoInitInstances;
	    };
	
	    /**
	     * The Parent half of a response iframe.
	     *
	     * @memberof module:pym
	     * @class Parent
	     * @param {String} id The id of the div into which the iframe will be rendered. sets {@link module:pym.Parent~id}
	     * @param {String} url The url of the iframe source. sets {@link module:pym.Parent~url}
	     * @param {Object} [config] Configuration for the parent instance. sets {@link module:pym.Parent~settings}
	     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
	     * @param {string} [config.title] - if passed it will be assigned to the iframe title attribute
	     * @param {string} [config.name] - if passed it will be assigned to the iframe name attribute
	     * @param {string} [config.id] - if passed it will be assigned to the iframe id attribute
	     * @param {boolean} [config.allowfullscreen] - if passed and different than false it will be assigned to the iframe allowfullscreen attribute
	     * @param {string} [config.sandbox] - if passed it will be assigned to the iframe sandbox attribute (we do not validate the syntax so be careful!!)
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe iFrame}
	     */
	    lib.Parent = function(id, url, config) {
	        /**
	         * The id of the container element
	         *
	         * @memberof module:pym.Parent
	         * @member {string} id
	         * @inner
	         */
	        this.id = id;
	        /**
	         * The url that will be set as the iframe's src
	         *
	         * @memberof module:pym.Parent
	         * @member {String} url
	         * @inner
	         */
	        this.url = url;
	
	        /**
	         * The container DOM object
	         *
	         * @memberof module:pym.Parent
	         * @member {HTMLElement} el
	         * @inner
	         */
	        this.el = document.getElementById(id);
	        /**
	         * The contained child iframe
	         *
	         * @memberof module:pym.Parent
	         * @member {HTMLElement} iframe
	         * @inner
	         * @default null
	         */
	        this.iframe = null;
	        /**
	         * The parent instance settings, updated by the values passed in the config object
	         *
	         * @memberof module:pym.Parent
	         * @member {Object} settings
	         * @inner
	         */
	        this.settings = {
	            xdomain: '*'
	        };
	        /**
	         * RegularExpression to validate the received messages
	         *
	         * @memberof module:pym.Parent
	         * @member {String} messageRegex
	         * @inner
	         */
	        this.messageRegex = _makeMessageRegex(this.id);
	        /**
	         * Stores the registered messageHandlers for each messageType
	         *
	         * @memberof module:pym.Parent
	         * @member {Object} messageHandlers
	         * @inner
	         */
	        this.messageHandlers = {};
	
	        // ensure a config object
	        config = (config || {});
	
	        /**
	         * Construct the iframe.
	         *
	         * @memberof module:pym.Parent
	         * @method _constructIframe
	         * @inner
	         */
	        this._constructIframe = function() {
	            // Calculate the width of this element.
	            var width = this.el.offsetWidth.toString();
	
	            // Create an iframe element attached to the document.
	            this.iframe = document.createElement('iframe');
	
	            // Save fragment id
	            var hash = '';
	            var hashIndex = this.url.indexOf('#');
	
	            if (hashIndex > -1) {
	                hash = this.url.substring(hashIndex, this.url.length);
	                this.url = this.url.substring(0, hashIndex);
	            }
	
	            // If the URL contains querystring bits, use them.
	            // Otherwise, just create a set of valid params.
	            if (this.url.indexOf('?') < 0) {
	                this.url += '?';
	            } else {
	                this.url += '&';
	            }
	
	            // Append the initial width as a querystring parameter, and the fragment id
	            this.iframe.src = this.url +
	                'initialWidth=' + width +
	                '&childId=' + this.id +
	                '&parentTitle=' + encodeURIComponent(document.title) +
	                '&parentUrl=' + encodeURIComponent(window.location.href) +
	                hash;
	
	            // Set some attributes to this proto-iframe.
	            this.iframe.setAttribute('width', '100%');
	            this.iframe.setAttribute('scrolling', 'no');
	            this.iframe.setAttribute('marginheight', '0');
	            this.iframe.setAttribute('frameborder', '0');
	
	            if (this.settings.title) {
	                this.iframe.setAttribute('title', this.settings.title);
	            }
	
	            if (this.settings.allowfullscreen !== undefined && this.settings.allowfullscreen !== false) {
	                this.iframe.setAttribute('allowfullscreen','');
	            }
	
	            if (this.settings.sandbox !== undefined && typeof this.settings.sandbox === 'string') {
	                this.iframe.setAttribute('sandbox', this.settings.sandbox);
	            }
	
	            if (this.settings.id) {
	                if (!document.getElementById(this.settings.id)) {
	                    this.iframe.setAttribute('id', this.settings.id);
	                }
	            }
	
	            if (this.settings.name) {
	                this.iframe.setAttribute('name', this.settings.name);
	            }
	
	            // Replace the child content if needed
	            // (some CMSs might strip out empty elements)
	            while(this.el.firstChild) { this.el.removeChild(this.el.firstChild); }
	            // Append the iframe to our element.
	            this.el.appendChild(this.iframe);
	
	            // Add an event listener that will handle redrawing the child on resize.
	            window.addEventListener('resize', this._onResize);
	        };
	
	        /**
	         * Send width on resize.
	         *
	         * @memberof module:pym.Parent
	         * @method _onResize
	         * @inner
	         */
	        this._onResize = function() {
	            this.sendWidth();
	        }.bind(this);
	
	        /**
	         * Fire all event handlers for a given message type.
	         *
	         * @memberof module:pym.Parent
	         * @method _fire
	         * @inner
	         *
	         * @param {String} messageType The type of message.
	         * @param {String} message The message data.
	         */
	        this._fire = function(messageType, message) {
	            if (messageType in this.messageHandlers) {
	                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
	                   this.messageHandlers[messageType][i].call(this, message);
	                }
	            }
	        };
	
	        /**
	         * Remove this parent from the page and unbind it's event handlers.
	         *
	         * @memberof module:pym.Parent
	         * @method remove
	         * @instance
	         */
	        this.remove = function() {
	            window.removeEventListener('message', this._processMessage);
	            window.removeEventListener('resize', this._onResize);
	
	            this.el.removeChild(this.iframe);
	            // _cleanAutoInitInstances in case this parent was autoInitialized
	            _cleanAutoInitInstances();
	        };
	
	        /**
	         * Process a new message from the child.
	         *
	         * @memberof module:pym.Parent
	         * @method _processMessage
	         * @inner
	         *
	         * @param {Event} e A message event.
	         */
	        this._processMessage = function(e) {
	            // First, punt if this isn't from an acceptable xdomain.
	            if (!_isSafeMessage(e, this.settings)) {
	                return;
	            }
	
	            // Discard object messages, we only care about strings
	            if (typeof e.data !== 'string') {
	                return;
	            }
	
	            // Grab the message from the child and parse it.
	            var match = e.data.match(this.messageRegex);
	
	            // If there's no match or too many matches in the message, punt.
	            if (!match || match.length !== 3) {
	                return false;
	            }
	
	            var messageType = match[1];
	            var message = match[2];
	
	            this._fire(messageType, message);
	        }.bind(this);
	
	        /**
	         * Resize iframe in response to new height message from child.
	         *
	         * @memberof module:pym.Parent
	         * @method _onHeightMessage
	         * @inner
	         *
	         * @param {String} message The new height.
	         */
	        this._onHeightMessage = function(message) {
	            /*
	             * Handle parent height message from child.
	             */
	            var height = parseInt(message);
	
	            this.iframe.setAttribute('height', height + 'px');
	        };
	
	        /**
	         * Navigate parent to a new url.
	         *
	         * @memberof module:pym.Parent
	         * @method _onNavigateToMessage
	         * @inner
	         *
	         * @param {String} message The url to navigate to.
	         */
	        this._onNavigateToMessage = function(message) {
	            /*
	             * Handle parent scroll message from child.
	             */
	            document.location.href = message;
	        };
	
	        /**
	         * Scroll parent to a given child position.
	         *
	         * @memberof module:pym.Parent
	         * @method _onScrollToChildPosMessage
	         * @inner
	         *
	         * @param {String} message The offset inside the child page.
	         */
	        this._onScrollToChildPosMessage = function(message) {
	            // Get the child container position using getBoundingClientRect + pageYOffset
	            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
	            var iframePos = document.getElementById(this.id).getBoundingClientRect().top + window.pageYOffset;
	
	            var totalOffset = iframePos + parseInt(message);
	            window.scrollTo(0, totalOffset);
	        };
	
	        /**
	         * Bind a callback to a given messageType from the child.
	         *
	         * Reserved message names are: "height", "scrollTo" and "navigateTo".
	         *
	         * @memberof module:pym.Parent
	         * @method onMessage
	         * @instance
	         *
	         * @param {String} messageType The type of message being listened for.
	         * @param {module:pym.Parent~onMessageCallback} callback The callback to invoke when a message of the given type is received.
	         */
	        this.onMessage = function(messageType, callback) {
	            if (!(messageType in this.messageHandlers)) {
	                this.messageHandlers[messageType] = [];
	            }
	
	            this.messageHandlers[messageType].push(callback);
	        };
	
	        /**
	         * @callback module:pym.Parent~onMessageCallback
	         * @param {String} message The message data.
	         */
	
	        /**
	         * Send a message to the the child.
	         *
	         * @memberof module:pym.Parent
	         * @method sendMessage
	         * @instance
	         *
	         * @param {String} messageType The type of message to send.
	         * @param {String} message The message data to send.
	         */
	        this.sendMessage = function(messageType, message) {
	            // When used alongside with pjax some references are lost
	            if (this.el.getElementsByTagName('iframe').length) {
	                if (this.el.getElementsByTagName('iframe')[0].contentWindow) {
	                    this.el.getElementsByTagName('iframe')[0].contentWindow
	                        .postMessage(_makeMessage(this.id, messageType, message), '*');
	                }
	                else {
	                    // Contentless child detected remove listeners and iframe
	                    this.remove();
	                }
	            }
	        };
	
	        /**
	         * Transmit the current iframe width to the child.
	         *
	         * You shouldn't need to call this directly.
	         *
	         * @memberof module:pym.Parent
	         * @method sendWidth
	         * @instance
	         */
	        this.sendWidth = function() {
	            var width = this.el.offsetWidth.toString();
	            this.sendMessage('width', width);
	        };
	
	        // Add any overrides to settings coming from config.
	        for (var key in config) {
	            this.settings[key] = config[key];
	        }
	
	        // Bind required message handlers
	        this.onMessage('height', this._onHeightMessage);
	        this.onMessage('navigateTo', this._onNavigateToMessage);
	        this.onMessage('scrollToChildPos', this._onScrollToChildPosMessage);
	
	        // Add a listener for processing messages from the child.
	        window.addEventListener('message', this._processMessage, false);
	
	        // Construct the iframe in the container element.
	        this._constructIframe();
	
	        return this;
	    };
	
	    /**
	     * The Child half of a responsive iframe.
	     *
	     * @memberof module:pym
	     * @class Child
	     * @param {Object} [config] Configuration for the child instance. sets {@link module:pym.Child~settings}
	     * @param {function} [config.renderCallback=null] Callback invoked after receiving a resize event from the parent, sets {@link module:pym.Child#settings.renderCallback}
	     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
	     * @param {number} [config.polling=0] - polling frequency in milliseconds to send height to parent
	     * @param {number} [config.id] - parent container id used when navigating the child iframe to a new page but we want to keep it responsive.
	     */
	    lib.Child = function(config) {
	        /**
	         * The initial width of the parent page
	         *
	         * @memberof module:pym.Child
	         * @member {string} parentWidth
	         * @inner
	         */
	        this.parentWidth = null;
	        /**
	         * The id of the parent container
	         *
	         * @memberof module:pym.Child
	         * @member {String} id
	         * @inner
	         */
	        this.id = null;
	        /**
	         * The title of the parent page from document.title.
	         *
	         * @memberof module:pym.Child
	         * @member {String} parentTitle
	         * @inner
	         */
	        this.parentTitle = null;
	        /**
	         * The URL of the parent page from window.location.href.
	         *
	         * @memberof module:pym.Child
	         * @member {String} parentUrl
	         * @inner
	         */
	        this.parentUrl = null;
	        /**
	         * The settings for the child instance. Can be overriden by passing a config object to the child constructor
	         * i.e.: var pymChild = new pym.Child({renderCallback: render, xdomain: "\\*\.npr\.org"})
	         *
	         * @memberof module:pym.Child.settings
	         * @member {Object} settings - default settings for the child instance
	         * @inner
	         */
	        this.settings = {
	            renderCallback: null,
	            xdomain: '*',
	            polling: 0
	        };
	
	        /**
	         * The timerId in order to be able to stop when polling is enabled
	         *
	         * @memberof module:pym.Child
	         * @member {String} timerId
	         * @inner
	         */
	        this.timerId = null;
	        /**
	         * RegularExpression to validate the received messages
	         *
	         * @memberof module:pym.Child
	         * @member {String} messageRegex
	         * @inner
	         */
	        this.messageRegex = null;
	        /**
	         * Stores the registered messageHandlers for each messageType
	         *
	         * @memberof module:pym.Child
	         * @member {Object} messageHandlers
	         * @inner
	         */
	        this.messageHandlers = {};
	
	        // Ensure a config object
	        config = (config || {});
	
	        /**
	         * Bind a callback to a given messageType from the child.
	         *
	         * Reserved message names are: "width".
	         *
	         * @memberof module:pym.Child
	         * @method onMessage
	         * @instance
	         *
	         * @param {String} messageType The type of message being listened for.
	         * @param {module:pym.Child~onMessageCallback} callback The callback to invoke when a message of the given type is received.
	         */
	        this.onMessage = function(messageType, callback) {
	
	            if (!(messageType in this.messageHandlers)) {
	                this.messageHandlers[messageType] = [];
	            }
	
	            this.messageHandlers[messageType].push(callback);
	        };
	
	        /**
	         * @callback module:pym.Child~onMessageCallback
	         * @param {String} message The message data.
	         */
	
	
	        /**
	         * Fire all event handlers for a given message type.
	         *
	         * @memberof module:pym.Child
	         * @method _fire
	         * @inner
	         *
	         * @param {String} messageType The type of message.
	         * @param {String} message The message data.
	         */
	        this._fire = function(messageType, message) {
	            /*
	             * Fire all event handlers for a given message type.
	             */
	            if (messageType in this.messageHandlers) {
	                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
	                   this.messageHandlers[messageType][i].call(this, message);
	                }
	            }
	        };
	
	        /**
	         * Process a new message from the parent.
	         *
	         * @memberof module:pym.Child
	         * @method _processMessage
	         * @inner
	         *
	         * @param {Event} e A message event.
	         */
	        this._processMessage = function(e) {
	            /*
	            * Process a new message from parent frame.
	            */
	            // First, punt if this isn't from an acceptable xdomain.
	            if (!_isSafeMessage(e, this.settings)) {
	                return;
	            }
	
	            // Discard object messages, we only care about strings
	            if (typeof e.data !== 'string') {
	                return;
	            }
	
	            // Get the message from the parent.
	            var match = e.data.match(this.messageRegex);
	
	            // If there's no match or it's a bad format, punt.
	            if (!match || match.length !== 3) { return; }
	
	            var messageType = match[1];
	            var message = match[2];
	
	            this._fire(messageType, message);
	        }.bind(this);
	
	        /**
	         * Resize iframe in response to new width message from parent.
	         *
	         * @memberof module:pym.Child
	         * @method _onWidthMessage
	         * @inner
	         *
	         * @param {String} message The new width.
	         */
	        this._onWidthMessage = function(message) {
	            /*
	             * Handle width message from the child.
	             */
	            var width = parseInt(message);
	
	            // Change the width if it's different.
	            if (width !== this.parentWidth) {
	                this.parentWidth = width;
	
	                // Call the callback function if it exists.
	                if (this.settings.renderCallback) {
	                    this.settings.renderCallback(width);
	                }
	
	                // Send the height back to the parent.
	                this.sendHeight();
	            }
	        };
	
	        /**
	         * Send a message to the the Parent.
	         *
	         * @memberof module:pym.Child
	         * @method sendMessage
	         * @instance
	         *
	         * @param {String} messageType The type of message to send.
	         * @param {String} message The message data to send.
	         */
	        this.sendMessage = function(messageType, message) {
	            /*
	             * Send a message to the parent.
	             */
	            window.parent.postMessage(_makeMessage(this.id, messageType, message), '*');
	        };
	
	        /**
	         * Transmit the current iframe height to the parent.
	         *
	         * Call this directly in cases where you manually alter the height of the iframe contents.
	         *
	         * @memberof module:pym.Child
	         * @method sendHeight
	         * @instance
	         */
	        this.sendHeight = function() {
	            // Get the child's height.
	            var height = document.getElementsByTagName('body')[0].offsetHeight.toString();
	
	            // Send the height to the parent.
	            this.sendMessage('height', height);
	
	            return height;
	        }.bind(this);
	
	        /**
	         * Scroll parent to a given element id.
	         *
	         * @memberof module:pym.Child
	         * @method scrollParentTo
	         * @instance
	         *
	         * @param {String} hash The id of the element to scroll to.
	         */
	        this.scrollParentTo = function(hash) {
	            this.sendMessage('navigateTo', '#' + hash);
	        };
	
	        /**
	         * Navigate parent to a given url.
	         *
	         * @memberof module:pym.Child
	         * @method navigateParentTo
	         * @instance
	         *
	         * @param {String} url The url to navigate to.
	         */
	        this.navigateParentTo = function(url) {
	            this.sendMessage('navigateTo', url);
	        };
	
	        /**
	         * Scroll parent to a given child element id.
	         *
	         * @memberof module:pym.Child
	         * @method scrollParentToChildEl
	         * @instance
	         *
	         * @param {String} id The id of the child element to scroll to.
	         */
	        this.scrollParentToChildEl = function(id) {
	            // Get the child element position using getBoundingClientRect + pageYOffset
	            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
	            var topPos = document.getElementById(id).getBoundingClientRect().top + window.pageYOffset;
	            this.scrollParentToChildPos(topPos);
	        };
	
	        /**
	         * Scroll parent to a particular child offset.
	         *
	         * @memberof module:pym.Child
	         * @method scrollParentToChildPos
	         * @instance
	         *
	         * @param {Number} pos The offset of the child element to scroll to.
	         */
	        this.scrollParentToChildPos = function(pos) {
	            this.sendMessage('scrollToChildPos', pos.toString());
	        };
	
	        /**
	         * Mark Whether the child is embedded or not
	         * executes a callback in case it was passed to the config
	         *
	         * @memberof module:pym.Child
	         * @method _markWhetherEmbedded
	         * @inner
	         *
	         * @param {module:pym.Child~onMarkedEmbeddedStatus} The callback to execute after determining whether embedded or not.
	         */
	        this._markWhetherEmbedded = function(onMarkedEmbeddedStatus) {
	          var htmlElement = document.getElementsByTagName('html')[0],
	              newClassForHtml,
	              originalHtmlClasses = htmlElement.className;
	          try {
	            if(window.self !== window.top) {
	              newClassForHtml = "embedded";
	            }else{
	              newClassForHtml = "not-embedded";
	            }
	          }catch(e) {
	            newClassForHtml = "embedded";
	          }
	          if(originalHtmlClasses.indexOf(newClassForHtml) < 0) {
	            htmlElement.className = originalHtmlClasses + newClassForHtml;
	            if(onMarkedEmbeddedStatus){
	              onMarkedEmbeddedStatus(newClassForHtml);
	            }
	          }
	        };
	
	        /**
	         * @callback module:pym.Child~onMarkedEmbeddedStatus
	         * @param {String} classname "embedded" or "not-embedded".
	         */
	
	        /**
	         * Unbind child event handlers and timers.
	         *
	         * @memberof module:pym.Child
	         * @method remove
	         * @instance
	         */
	        this.remove = function() {
	            window.removeEventListener('message', this._processMessage);
	            if (this.timerId) {
	                clearInterval(this.timerId);
	            }
	        };
	
	        // Identify what ID the parent knows this child as.
	        this.id = _getParameterByName('childId') || config.id;
	        this.messageRegex = new RegExp('^pym' + MESSAGE_DELIMITER + this.id + MESSAGE_DELIMITER + '(\\S+)' + MESSAGE_DELIMITER + '(.*)$');
	
	        // Get the initial width from a URL parameter.
	        var width = parseInt(_getParameterByName('initialWidth'));
	
	        // Get the url of the parent frame
	        this.parentUrl = _getParameterByName('parentUrl');
	
	        // Get the title of the parent frame
	        this.parentTitle = _getParameterByName('parentTitle');
	
	        // Bind the required message handlers
	        this.onMessage('width', this._onWidthMessage);
	
	        // Initialize settings with overrides.
	        for (var key in config) {
	            this.settings[key] = config[key];
	        }
	
	        // Set up a listener to handle any incoming messages.
	        window.addEventListener('message', this._processMessage, false);
	
	        // If there's a callback function, call it.
	        if (this.settings.renderCallback) {
	            this.settings.renderCallback(width);
	        }
	
	        // Send the initial height to the parent.
	        this.sendHeight();
	
	        // If we're configured to poll, create a setInterval to handle that.
	        if (this.settings.polling) {
	            this.timerId = window.setInterval(this.sendHeight, this.settings.polling);
	        }
	
	        this._markWhetherEmbedded(config.onMarkedEmbeddedStatus);
	
	        return this;
	    };
	
	    // Initialize elements with pym data attributes
	    lib.autoInit();
	
	    return lib;
	});
	


/***/ },
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopNews = function (_Component) {
	  _inherits(TopNews, _Component);
	
	  function TopNews() {
	    _classCallCheck(this, TopNews);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TopNews.prototype.render = function render() {
	    var timestamp = new Date(this.props.topNewsTimestamp);
	
	    var hours = timestamp.getHours();
	    var minutes = timestamp.getMinutes();
	    if (String(minutes).length < 2) {
	      minutes = '0' + minutes;
	    }
	    var suffix = hours >= 12 ? 'PM' : 'AM';
	
	    var time = (hours > 12 ? hours - 12 : hours) + ':' + minutes + ' ' + suffix;
	
	    var posts = this.props.posts.map(function (post, idx) {
	      return (0, _preact.h)('li', { className: 'news-list__item', key: idx, dangerouslySetInnerHTML: { __html: post.value } });
	    });
	
	    var electionCoverageButton = null;
	
	    if (this.props.includeElectionCoverageButton) {
	      electionCoverageButton = (0, _preact.h)(
	        'a',
	        { className: 'button button--yellow', href: 'https://www.texastribune.org/2016/texas-elections/' },
	        'View all election coverage \xBB'
	      );
	    }
	
	    return (0, _preact.h)(
	      'div',
	      { className: 'widget' },
	      (0, _preact.h)(
	        'header',
	        { className: 'widget__titlebar' },
	        (0, _preact.h)(
	          'h2',
	          { className: 'widget__title' },
	          'Top news'
	        ),
	        (0, _preact.h)(
	          'p',
	          { className: 'widget__sub-title' },
	          'Updated: ',
	          (0, _preact.h)(
	            'time',
	            null,
	            time
	          )
	        )
	      ),
	      (0, _preact.h)(
	        'div',
	        { className: 'widget__content' },
	        (0, _preact.h)(
	          'ul',
	          { className: 'news-list' },
	          posts
	        )
	      ),
	      electionCoverageButton
	    );
	  };
	
	  return TopNews;
	}(_preact.Component);
	
	exports.default = TopNews;

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTopNews;
	/* global fetch */
	
	var topNewsURL = 'https://s3.amazonaws.com/sos.texastribune.org/top-news/data.json';
	
	function getTopNews() {
	  return fetch(topNewsURL + '?__=' + +new Date()).then(function (res) {
	    return res.json();
	  });
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* Tock by Mr Chimp - github.com/mrchimp/tock
	* Based on code by James Edwards:
	*    sitepoint.com/creating-accurate-timers-in-javascript/
	*/
	
	// Implements Date.now() for ie lt 9
	Date.now = Date.now || function() { return +new Date(); };
	
	// Polyfills Function.prototype.bind for IE lt 9 and Safari lt 5.1
	if ( typeof Function.prototype.bind != 'function' ) {
	    Function.prototype.bind = function (ctx) {
	        var args = Array.prototype.slice.call(arguments, 1),
	            fn = this;
	        return function () {
	            args.push.apply(args, arguments);
	            return fn.apply(ctx, args);
	        };
	    };
	}
	
	(function (root, factory) {
	  if ( true ) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports === 'object' ) {
	    module.exports = factory();
	  } else {
	    root.Tock = factory();
	  }
	}(this, function () {
	
	  /**
	   * Called every tick for countdown clocks.
	   * i.e. once every this.interval ms
	   */
	  function _tick () {
	    this.time += this.interval;
	
	    if ( this.countdown && (this.duration_ms - this.time < 0) ) {
	      this.final_time = 0;
	      this.go = false;
	      this.callback(this);
	      clearTimeout(this.timeout);
	      this.complete(this);
	      return;
	    } else {
	      this.callback(this);
	    }
	
	    var diff = (Date.now() - this.start_time) - this.time,
	        next_interval_in = diff > 0 ? this.interval - diff : this.interval;
	
	    if ( next_interval_in <= 0 ) {
	      this.missed_ticks = Math.floor(Math.abs(next_interval_in) / this.interval);
	      this.time += this.missed_ticks * this.interval;
	
	      if ( this.go ) {
	        _tick.call(this);
	      }
	    } else if ( this.go ) {
	      this.timeout = setTimeout(_tick.bind(this), next_interval_in);
	    }
	  }
	
	  /**
	   * Called by Tock internally - use start() instead
	   */
	  function _startCountdown (duration) {
	    this.duration_ms = duration;
	    this.start_time = Date.now();
	    this.time = 0;
	    this.go = true;
	    _tick.call(this);
	  }
	
	  /**
	   * Called by Tock internally - use start() instead
	   */
	  function _startTimer (start_offset) {
	    this.start_time = start_offset || Date.now();
	    this.time = 0;
	    this.go = true;
	    _tick.call(this);
	  }
	
	  var MILLISECONDS_RE           = /^\s*(\+|-)?\d+\s*$/,
	      MM_SS_RE                  = /^(\d{1,2}):(\d{2})$/,
	      MM_SS_ms_OR_HH_MM_SS_RE   = /^(\d{1,2}):(\d{2})(?::|\.)(\d{2,3})$/,
	      MS_PER_HOUR               = 3600000,
	      MS_PER_MIN                = 60000,
	      MS_PER_SEC                = 1000,
	      /* The RegExp below will match a date in format `yyyy-mm-dd HH:MM:SS` and optionally with `.ms` at the end.
	       * It will also match ISO date string, i.e. if the whitespace separator in the middle is replaced with a `T`
	       * and the date string is also suffixed with a `Z` denoting UTC timezone.
	       */
	      yyyy_mm_dd_HH_MM_SS_ms_RE = /^(\d{4})-([0-1]\d)-([0-3]\d)(?:\s|T)(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3})Z?)?$/;
	
	  var Tock = function (options) {
	    options = options || {};
	
	    if ( ! (this instanceof Tock) ) return new Tock(options);
	
	    Tock.instances = (Tock.instances || 0) + 1;
	
	    this.go           = false;
	    this.timeout      = null;
	    this.missed_ticks = null;
	    this.interval     = options.interval || 10;
	    this.countdown    = options.countdown || false;
	    this.start_time   = 0;
	    this.pause_time   = 0;
	    this.final_time   = 0;
	    this.duration_ms  = 0;
	    this.time         = 0;
	    this.callback     = options.callback || function () {};
	    this.complete     = options.complete || function () {};
	  };
	
	  /**
	   * Reset the clock
	   */
	  Tock.prototype.reset = function () {
	    if ( this.countdown ) {
	      return false;
	    }
	
	    this.stop();
	    this.start_time = 0;
	    this.time = 0;
	  };
	
	  /**
	   * Start the clock.
	   * @param {Various} time Accepts a single "time" argument
	   *   which can be in various forms:
	   *   - MM:SS
	   *   - MM:SS:ms or MM:SS.ms
	   *   - HH:MM:SS
	   *   - yyyy-mm-dd HH:MM:SS.ms
	   *   - milliseconds
	   */
	  Tock.prototype.start = function (time) {
	    if (this.go) return false;
	
	    time = time ? this.timeToMS(time) : 0;
	
	    this.start_time = time;
	    this.pause_time = 0;
	
	    if ( this.countdown ) {
	      _startCountdown.call(this, time);
	    } else {
	      _startTimer.call(this, Date.now() - time);
	    }
	  };
	
	  /**
	   * Stop the clock and clear the timeout
	   */
	  Tock.prototype.stop = function () {
	    this.pause_time = this.lap();
	    this.go = false;
	
	    clearTimeout(this.timeout);
	
	    if ( this.countdown ) {
	      this.final_time = this.duration_ms - this.time;
	    } else {
	      this.final_time = (Date.now() - this.start_time);
	    }
	  };
	
	  /**
	   * Stop/start the clock.
	   */
	  Tock.prototype.pause = function () {
	    if ( this.go ) {
	      this.pause_time = this.lap();
	      this.stop();
	    } else {
	      if ( this.pause_time ) {
	        if ( this.countdown ) {
	          _startCountdown.call(this, this.pause_time);
	        } else {
	          _startTimer.call(this, Date.now() - this.pause_time);
	        }
	
	        this.pause_time = 0;
	      }
	    }
	  };
	
	  /**
	   * Get the current clock time in ms.
	   * Use with Tock.msToTime() to make it look nice.
	   * @return {Integer} Number of milliseconds ellapsed/remaining
	   */
	  Tock.prototype.lap = function () {
	    if ( this.go ) {
	      var now;
	
	      if ( this.countdown ) {
	        now = this.duration_ms - (Date.now() - this.start_time);
	      } else {
	        now = (Date.now() - this.start_time);
	      }
	
	      return now;
	    }
	
	    return this.pause_time || this.final_time;
	  };
	
	  /**
	   * Format milliseconds as a MM:SS.ms string.
	   * @param  {Integer} ms Number of milliseconds
	   * @return {String}     String representation of ms in format MM:SS:ms
	   */
	  Tock.prototype.msToTime = function (ms) {
	    var milliseconds = this.zeroPad(ms % MS_PER_SEC, 3),
	        seconds = this.zeroPad(Math.floor((ms / MS_PER_SEC) % 60), 2),
	        minutes = this.zeroPad(Math.floor((ms / (MS_PER_MIN)) % 60), 2);
	
	    return minutes + ':' + seconds + '.' + milliseconds;
	  };
	
	  /**
	   * Pad the left side of a string with zeros up to a given length. I
	   * considered using an NPM package for this but it's probably best not to.
	   * @param  {Various} input  Number to pad. Will be converted to string.
	   * @param  {Integer} length Desired string length
	   * @return {String}         Padding number
	   */
	  Tock.prototype.zeroPad = function (input, length) {
	    input = input.toString();
	
	    while ( input.length < length ) {
	      input = '0' + input;
	    }
	
	    return input;
	  };
	
	  /**
	   * Format milliseconds as HH:MM:SS or HH:MM:SS:mmm
	   * @param  {Integer} ms      Number of milliseconds
	   * @param  {Boolean} show_ms If true, include milliseconds in output
	   * @return {String}          Formatted timecode string
	   */
	  Tock.prototype.msToTimecode = function (ms, show_ms) {
	    var seconds  = this.zeroPad(Math.floor((ms / MS_PER_SEC)  % 60), 2),
	        minutes  = this.zeroPad(Math.floor((ms / MS_PER_MIN)  % 60), 2),
	        hours    = this.zeroPad(Math.floor((ms / MS_PER_HOUR) % 60), 2),
	        millisec = (show_ms ? ':' + this.zeroPad(Math.floor(ms % MS_PER_SEC), 3) : '');
	
	    return hours + ':' + minutes + ':' + seconds + millisec;
	  };
	
	  /**
	   * Convert a time string to milliseconds
	   *
	   * Possible inputs:
	   * MM:SS
	   * MM:SS:ms or MM:SS.ms
	   * HH:MM:SS
	   * yyyy-mm-dd HH:MM:SS.ms
	   *
	   * A milliseconds input will return it back for safety
	   * If the input cannot be recognized then 0 is returned
	   */
	  Tock.prototype.timeToMS = function (time) {
	    // If input is milliseconds integer then return it back
	    if ( MILLISECONDS_RE.test(String(time)) ) {
	      return time;
	    }
	
	    var ms,
	        time_split,
	        match,
	        date,
	        now = new Date();
	
	    if ( MM_SS_RE.test(time) ) { // If MM:SS
	      time_split = time.split(':');
	      ms = parseInt(time_split[0], 10) * MS_PER_MIN;
	      ms += parseInt(time_split[1], 10) * MS_PER_SEC;
	    } else {
	      match = time.match(MM_SS_ms_OR_HH_MM_SS_RE);
	
	      if ( match ) {
	        if ( match[3].length == 3 || parseInt(match[3], 10) > 59 ) { // If MM:SS:ms or MM:SS.ms (e.g. 10:10:458 or 10:10.458)
	          ms = parseInt(match[1], 10) * MS_PER_MIN;
	          ms += parseInt(match[2], 10) * MS_PER_SEC;
	          ms += parseInt(match[3], 10);
	        } else { // Then it's HH:MM:SS
	          ms = parseInt(match[1], 10) * MS_PER_HOUR;
	          ms += parseInt(match[2], 10) * MS_PER_MIN;
	          ms += parseInt(match[3], 10) * MS_PER_SEC;
	        }
	      } else if ( yyyy_mm_dd_HH_MM_SS_ms_RE.test(time) ) { // If yyyy-mm-dd HH:MM:SS or yyyy-mm-dd HH:MM:SS.ms or yyyy-mm-ddTHH:MM:SS.msZ
	        date = new Date();
	        now = new Date();
	
	        match = time.match(yyyy_mm_dd_HH_MM_SS_ms_RE);
	
	        date.setYear(match[1]);
	        date.setMonth(match[2]);
	        date.setDate(match[3]);
	        date.setHours(match[4]);
	        date.setMinutes(match[5]);
	        date.setSeconds(match[6]);
	
	        if (typeof match[7] !== 'undefined') {
	          date.setMilliseconds(match[7]);
	        }
	
	        ms = Math.max(0, date.getTime() - now.getTime());
	      } else {
	        // Let's try it as a date string
	        now = new Date();
	        ms = Date.parse(time);
	
	        if ( !isNaN(ms) ) { // Looks ok
	          ms = Math.max(0, ms - now.getTime());
	        } else { // Could not recognize input, so start from 0
	          ms = 0;
	        }
	      }
	    }
	
	    return ms;
	  };
	
	  return Tock;
	}));


/***/ },
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _race = __webpack_require__(6);
	
	var _race2 = _interopRequireDefault(_race);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Results = function (_Component) {
	  _inherits(Results, _Component);
	
	  function Results() {
	    _classCallCheck(this, Results);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Results.prototype.render = function render() {
	    var _this2 = this;
	
	    var races = this.props.races;
	    var racesFilter = this.props.racesFilter;
	
	    var results = races;
	
	    if (racesFilter && racesFilter !== 'all' && racesFilter !== 'my-races') {
	      results = results.filter(function (race) {
	        return racesFilter === race.office_slug;
	      });
	    }
	
	    if (racesFilter === 'my-races') {
	      (function () {
	        var selected = _this2.base.querySelectorAll('.race__save-input:checked');
	
	        var ids = [];
	
	        for (var i = 0; i < selected.length; ++i) {
	          ids.push(+selected[i].value);
	        }
	
	        results = results.filter(function (race) {
	          return ids.indexOf(race.id) >= 0;
	        });
	      })();
	    }
	
	    results = results.map(function (race) {
	      return (0, _preact.h)(_race2.default, { scoreboard: _this2.props.scoreboard, key: race.id, race: race });
	    });
	
	    var klass = null;
	
	    if (this.props.scoreboard) {
	      klass = 'scoreboard';
	    }
	
	    return (0, _preact.h)(
	      'div',
	      { className: klass },
	      results
	    );
	  };
	
	  return Results;
	}(_preact.Component);
	
	exports.default = Results;

/***/ },
/* 17 */,
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getResults;
	/* global fetch */
	
	var resultsURL = 'https://s3.amazonaws.com/sos.texastribune.org/results/2016-general.json';
	
	function getResults() {
	  return fetch(resultsURL + '?__=' + +new Date()).then(function (res) {
	    return res.json();
	  });
	}

/***/ },
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _pym = __webpack_require__(8);
	
	var _pym2 = _interopRequireDefault(_pym);
	
	var _tocktimer = __webpack_require__(13);
	
	var _tocktimer2 = _interopRequireDefault(_tocktimer);
	
	var _countdown = __webpack_require__(4);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _results = __webpack_require__(16);
	
	var _results2 = _interopRequireDefault(_results);
	
	var _topNews = __webpack_require__(11);
	
	var _topNews2 = _interopRequireDefault(_topNews);
	
	var _getParameterByName = __webpack_require__(32);
	
	var _getParameterByName2 = _interopRequireDefault(_getParameterByName);
	
	var _getResults = __webpack_require__(18);
	
	var _getResults2 = _interopRequireDefault(_getResults);
	
	var _getTopNews = __webpack_require__(12);
	
	var _getTopNews2 = _interopRequireDefault(_getTopNews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldIncludeTopNews = (0, _getParameterByName2.default)('top-news') === '1';
	var raceIds = (0, _getParameterByName2.default)('ids');
	
	var racesToInclude = void 0;
	
	if (raceIds) {
	  racesToInclude = (0, _getParameterByName2.default)('ids').split(',').map(function (id) {
	    return +id;
	  });
	} else {
	  racesToInclude = [553]; // only U.S. President
	}
	
	var EmbedContainer = function (_Component) {
	  _inherits(EmbedContainer, _Component);
	
	  function EmbedContainer() {
	    _classCallCheck(this, EmbedContainer);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      races: [],
	      posts: [],
	      topNewsTimestamp: null,
	      timeLeft: 0
	    };
	
	    _this.child = new _pym2.default.Child();
	
	    _this.onTick = _this.onTick.bind(_this);
	    _this.onComplete = _this.onComplete.bind(_this);
	
	    _this.duration = 30 * 1000;
	
	    _this.timer = new _tocktimer2.default({
	      countdown: true,
	      interval: 1000,
	      callback: _this.onTick,
	      complete: _this.onComplete
	    });
	    return _this;
	  }
	
	  EmbedContainer.prototype.onTick = function onTick() {
	    var now = Math.ceil(this.timer.lap() / 1000);
	    this.setState({
	      timeLeft: now === 0 ? 'Updating!' : now
	    });
	  };
	
	  EmbedContainer.prototype.onComplete = function onComplete() {
	    this.fetchData();
	  };
	
	  EmbedContainer.prototype.fetchData = function fetchData() {
	    var _this2 = this;
	
	    var requests = [];
	
	    if (shouldIncludeTopNews) {
	      var whenGetTopNews = (0, _getTopNews2.default)().then(function (topNews) {
	        var posts = topNews.data.top_news;
	        var topNewsTimestamp = topNews.timestamp;
	
	        _this2.setState({ posts: posts, topNewsTimestamp: topNewsTimestamp });
	      });
	
	      requests.push(whenGetTopNews);
	    }
	
	    var whenGetResults = (0, _getResults2.default)().then(function (races) {
	      var activeRaces = races.filter(function (race) {
	        return racesToInclude.indexOf(race.id) >= 0;
	      });
	
	      _this2.setState({ races: activeRaces });
	    });
	
	    requests.push(whenGetResults);
	
	    Promise.all(requests).then(function () {
	      _this2.timer.start(_this2.duration);
	    });
	  };
	
	  EmbedContainer.prototype.componentDidMount = function componentDidMount() {
	    this.fetchData();
	    this.child.sendHeight();
	  };
	
	  EmbedContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.child.sendHeight();
	  };
	
	  EmbedContainer.prototype.render = function render() {
	    var topNewsElement = null;
	
	    if (shouldIncludeTopNews) {
	      topNewsElement = (0, _preact.h)(_topNews2.default, { topNewsTimestamp: this.state.topNewsTimestamp, posts: this.state.posts });
	    }
	
	    return (0, _preact.h)(
	      'div',
	      null,
	      (0, _preact.h)(_countdown2.default, { alignment: 'center', timeLeft: this.state.timeLeft }),
	      (0, _preact.h)(_results2.default, { races: this.state.races }),
	      topNewsElement
	    );
	  };
	
	  return EmbedContainer;
	}(_preact.Component);
	
	exports.default = EmbedContainer;

/***/ },
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getParameterByName;
	function getParameterByName(name, url) {
	  if (!url) {
	    url = window.location.href;
	  }
	  name = name.replace(/[[\]]/g, '\\$&');
	  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	  var results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(__webpack_require__(1)) :
	  typeof define === 'function' && define.amd ? define(['preact'], factory) :
	  (factory(global.preact));
	}(this, function (preact) { 'use strict';
	
	  var babelHelpers = {};
	
	  babelHelpers.inherits = function (subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  };
	
	  babelHelpers.classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	  var ATTR_KEY = typeof Symbol !== 'undefined' ? Symbol['for']('preactattr') : '__preactattr_';
	
	  /** @private is the given object a Function? */
	
	  function isFunction(obj) {
	  	return 'function' === typeof obj;
	  }
	
	  /** Check if a VNode is a reference to a stateless functional component.
	   *	A function component is represented as a VNode whose `nodeName` property is a reference to a function.
	   *	If that function is not a Component (ie, has no `.render()` method on a prototype), it is considered a stateless functional component.
	   *	@param {VNode} vnode	A VNode
	   *	@private
	   */
	
	  function isFunctionalComponent(vnode) {
	    var nodeName = vnode && vnode.nodeName;
	    return nodeName && isFunction(nodeName) && !(nodeName.prototype && nodeName.prototype.render);
	  }
	
	  /**
	   * Return a ReactElement-compatible object for the current state of a preact
	   * component.
	   */
	  function createReactElement(component) {
	  	return {
	  		type: component.constructor,
	  		key: component.key,
	  		ref: null, // Unsupported
	  		props: component.props
	  	};
	  }
	
	  /**
	   * Create a ReactDOMComponent-compatible object for a given DOM node rendered
	   * by preact.
	   *
	   * This implements the subset of the ReactDOMComponent interface that
	   * React DevTools requires in order to display DOM nodes in the inspector with
	   * the correct type and properties.
	   *
	   * @param {Node} node
	   */
	  function createReactDOMComponent(node) {
	  	var childNodes = node.nodeType === Node.ELEMENT_NODE ? Array.from(node.childNodes) : [];
	
	  	var isText = node.nodeType === Node.TEXT_NODE;
	
	  	return {
	  		// --- ReactDOMComponent interface
	  		_currentElement: isText ? node.textContent : {
	  			type: node.nodeName.toLowerCase(),
	  			props: node[ATTR_KEY]
	  		},
	  		_renderedChildren: childNodes.map(function (child) {
	  			if (child._component) {
	  				return updateReactComponent(child._component);
	  			}
	  			return updateReactComponent(child);
	  		}),
	  		_stringText: isText ? node.textContent : null,
	
	  		// --- Additional properties used by preact devtools
	
	  		// A flag indicating whether the devtools have been notified about the
	  		// existence of this component instance yet.
	  		// This is used to send the appropriate notifications when DOM components
	  		// are added or updated between composite component updates.
	  		_inDevTools: false,
	  		node: node
	  	};
	  }
	
	  /**
	   * Return the name of a component created by a `ReactElement`-like object.
	   *
	   * @param {ReactElement} element
	   */
	  function typeName(element) {
	  	if (typeof element.type === 'function') {
	  		return element.type.displayName || element.type.name;
	  	}
	  	return element.type;
	  }
	
	  /**
	   * Return a ReactCompositeComponent-compatible object for a given preact
	   * component instance.
	   *
	   * This implements the subset of the ReactCompositeComponent interface that
	   * the DevTools requires in order to walk the component tree and inspect the
	   * component's properties.
	   *
	   * See https://github.com/facebook/react-devtools/blob/e31ec5825342eda570acfc9bcb43a44258fceb28/backend/getData.js
	   */
	  function createReactCompositeComponent(component) {
	  	var _currentElement = createReactElement(component);
	  	var node = component.base;
	
	  	var instance = {
	  		// --- ReactDOMComponent properties
	  		getName: function getName() {
	  			return typeName(_currentElement);
	  		},
	  		_currentElement: createReactElement(component),
	  		props: component.props,
	  		state: component.state,
	  		forceUpdate: component.forceUpdate.bind(component),
	  		setState: component.setState.bind(component),
	
	  		// --- Additional properties used by preact devtools
	  		node: node
	  	};
	
	  	// React DevTools exposes the `_instance` field of the selected item in the
	  	// component tree as `$r` in the console.  `_instance` must refer to a
	  	// React Component (or compatible) class instance with `props` and `state`
	  	// fields and `setState()`, `forceUpdate()` methods.
	  	instance._instance = component;
	
	  	// If the root node returned by this component instance's render function
	  	// was itself a composite component, there will be a `_component` property
	  	// containing the child component instance.
	  	if (component._component) {
	  		instance._renderedComponent = updateReactComponent(component._component);
	  	} else {
	  		// Otherwise, if the render() function returned an HTML/SVG element,
	  		// create a ReactDOMComponent-like object for the DOM node itself.
	  		instance._renderedComponent = updateReactComponent(node);
	  	}
	
	  	return instance;
	  }
	
	  /**
	   * Map of Component|Node to ReactDOMComponent|ReactCompositeComponent-like
	   * object.
	   *
	   * The same React*Component instance must be used when notifying devtools
	   * about the initial mount of a component and subsequent updates.
	   */
	  var instanceMap = new Map();
	
	  /**
	   * Update (and create if necessary) the ReactDOMComponent|ReactCompositeComponent-like
	   * instance for a given preact component instance or DOM Node.
	   *
	   * @param {Component|Node} componentOrNode
	   */
	  function updateReactComponent(componentOrNode) {
	  	var newInstance = componentOrNode instanceof Node ? createReactDOMComponent(componentOrNode) : createReactCompositeComponent(componentOrNode);
	  	if (instanceMap.has(componentOrNode)) {
	  		var inst = instanceMap.get(componentOrNode);
	  		Object.assign(inst, newInstance);
	  		return inst;
	  	}
	  	instanceMap.set(componentOrNode, newInstance);
	  	return newInstance;
	  }
	
	  function nextRootKey(roots) {
	  	return '.' + Object.keys(roots).length;
	  }
	
	  /**
	   * Find all root component instances rendered by preact in `node`'s children
	   * and add them to the `roots` map.
	   *
	   * @param {DOMElement} node
	   * @param {[key: string] => ReactDOMComponent|ReactCompositeComponent}
	   */
	  function findRoots(node, roots) {
	  	Array.from(node.childNodes).forEach(function (child) {
	  		if (child._component) {
	  			roots[nextRootKey(roots)] = updateReactComponent(child._component);
	  		} else {
	  			findRoots(child, roots);
	  		}
	  	});
	  }
	
	  /**
	   * Map of functional component name -> wrapper class.
	   */
	  var functionalComponentWrappers = new Map();
	
	  /**
	   * Wrap a functional component with a stateful component.
	   *
	   * preact does not record any information about the original hierarchy of
	   * functional components in the rendered DOM nodes. Wrapping functional components
	   * with a trivial wrapper allows us to recover information about the original
	   * component structure from the DOM.
	   *
	   * @param {VNode} vnode
	   */
	  function wrapFunctionalComponent(vnode) {
	  	var originalRender = vnode.nodeName;
	  	var name = vnode.nodeName.name || '(Function.name missing)';
	  	var wrappers = functionalComponentWrappers;
	  	if (!wrappers.has(originalRender)) {
	  		(function () {
	  			var wrapper = (function (_Component) {
	  				babelHelpers.inherits(wrapper, _Component);
	
	  				function wrapper() {
	  					babelHelpers.classCallCheck(this, wrapper);
	
	  					_Component.apply(this, arguments);
	  				}
	
	  				wrapper.prototype.render = function render(props, state, context) {
	  					return originalRender(props, context);
	  				};
	
	  				return wrapper;
	  			})(preact.Component);
	
	  			// Expose the original component name. React Dev Tools will use
	  			// this property if it exists or fall back to Function.name
	  			// otherwise.
	  			wrapper.displayName = name;
	
	  			wrappers.set(originalRender, wrapper);
	  		})();
	  	}
	  	vnode.nodeName = wrappers.get(originalRender);
	  }
	
	  /**
	   * Create a bridge for exposing preact's component tree to React DevTools.
	   *
	   * It creates implementations of the interfaces that ReactDOM passes to
	   * devtools to enable it to query the component tree and hook into component
	   * updates.
	   *
	   * See https://github.com/facebook/react/blob/59ff7749eda0cd858d5ee568315bcba1be75a1ca/src/renderers/dom/ReactDOM.js
	   * for how ReactDOM exports its internals for use by the devtools and
	   * the `attachRenderer()` function in
	   * https://github.com/facebook/react-devtools/blob/e31ec5825342eda570acfc9bcb43a44258fceb28/backend/attachRenderer.js
	   * for how the devtools consumes the resulting objects.
	   */
	  function createDevToolsBridge() {
	  	// The devtools has different paths for interacting with the renderers from
	  	// React Native, legacy React DOM and current React DOM.
	  	//
	  	// Here we emulate the interface for the current React DOM (v15+) lib.
	
	  	// ReactDOMComponentTree-like object
	  	var ComponentTree = {
	  		getNodeFromInstance: function getNodeFromInstance(instance) {
	  			return instance.node;
	  		},
	  		getClosestInstanceFromNode: function getClosestInstanceFromNode(node) {
	  			while (node && !node._component) {
	  				node = node.parentNode;
	  			}
	  			return node ? updateReactComponent(node._component) : null;
	  		}
	  	};
	
	  	// Map of root ID (the ID is unimportant) to component instance.
	  	var roots = {};
	  	findRoots(document.body, roots);
	
	  	// ReactMount-like object
	  	//
	  	// Used by devtools to discover the list of root component instances and get
	  	// notified when new root components are rendered.
	  	var Mount = {
	  		_instancesByReactRootID: roots,
	
	  		// Stub - React DevTools expects to find this method and replace it
	  		// with a wrapper in order to observe new root components being added
	  		_renderNewRootComponent: function _renderNewRootComponent() /* instance, ... */{}
	  	};
	
	  	// ReactReconciler-like object
	  	var Reconciler = {
	  		// Stubs - React DevTools expects to find these methods and replace them
	  		// with wrappers in order to observe components being mounted, updated and
	  		// unmounted
	  		mountComponent: function mountComponent() /* instance, ... */{},
	  		performUpdateIfNecessary: function performUpdateIfNecessary() /* instance, ... */{},
	  		receiveComponent: function receiveComponent() /* instance, ... */{},
	  		unmountComponent: function unmountComponent() /* instance, ... */{}
	  	};
	
	  	/** Notify devtools that a new component instance has been mounted into the DOM. */
	  	var componentAdded = function componentAdded(component) {
	  		var instance = updateReactComponent(component);
	  		if (isRootComponent(component)) {
	  			instance._rootID = nextRootKey(roots);
	  			roots[instance._rootID] = instance;
	  			Mount._renderNewRootComponent(instance);
	  		}
	  		visitNonCompositeChildren(instance, function (childInst) {
	  			childInst._inDevTools = true;
	  			Reconciler.mountComponent(childInst);
	  		});
	  		Reconciler.mountComponent(instance);
	  	};
	
	  	/** Notify devtools that a component has been updated with new props/state. */
	  	var componentUpdated = function componentUpdated(component) {
	  		var prevRenderedChildren = [];
	  		visitNonCompositeChildren(instanceMap.get(component), function (childInst) {
	  			prevRenderedChildren.push(childInst);
	  		});
	
	  		// Notify devtools about updates to this component and any non-composite
	  		// children
	  		var instance = updateReactComponent(component);
	  		Reconciler.receiveComponent(instance);
	  		visitNonCompositeChildren(instance, function (childInst) {
	  			if (!childInst._inDevTools) {
	  				// New DOM child component
	  				childInst._inDevTools = true;
	  				Reconciler.mountComponent(childInst);
	  			} else {
	  				// Updated DOM child component
	  				Reconciler.receiveComponent(childInst);
	  			}
	  		});
	
	  		// For any non-composite children that were removed by the latest render,
	  		// remove the corresponding ReactDOMComponent-like instances and notify
	  		// the devtools
	  		prevRenderedChildren.forEach(function (childInst) {
	  			if (!document.body.contains(childInst.node)) {
	  				instanceMap['delete'](childInst.node);
	  				Reconciler.unmountComponent(childInst);
	  			}
	  		});
	  	};
	
	  	/** Notify devtools that a component has been unmounted from the DOM. */
	  	var componentRemoved = function componentRemoved(component) {
	  		var instance = updateReactComponent(component);
	  		visitNonCompositeChildren(function (childInst) {
	  			instanceMap['delete'](childInst.node);
	  			Reconciler.unmountComponent(childInst);
	  		});
	  		Reconciler.unmountComponent(instance);
	  		instanceMap['delete'](component);
	  		if (instance._rootID) {
	  			delete roots[instance._rootID];
	  		}
	  	};
	
	  	return {
	  		componentAdded: componentAdded,
	  		componentUpdated: componentUpdated,
	  		componentRemoved: componentRemoved,
	
	  		// Interfaces passed to devtools via __REACT_DEVTOOLS_GLOBAL_HOOK__.inject()
	  		ComponentTree: ComponentTree,
	  		Mount: Mount,
	  		Reconciler: Reconciler
	  	};
	  }
	
	  /**
	   * Return `true` if a preact component is a top level component rendered by
	   * `render()` into a container Element.
	   */
	  function isRootComponent(component) {
	  	return !component.base.parentElement || !component.base.parentElement[ATTR_KEY];
	  }
	
	  /**
	   * Visit all child instances of a ReactCompositeComponent-like object that are
	   * not composite components (ie. they represent DOM elements or text)
	   *
	   * @param {Component} component
	   * @param {(Component) => void} visitor
	   */
	  function visitNonCompositeChildren(component, visitor) {
	  	if (component._renderedComponent) {
	  		if (!component._renderedComponent._component) {
	  			visitor(component._renderedComponent);
	  			visitNonCompositeChildren(component._renderedComponent, visitor);
	  		}
	  	} else if (component._renderedChildren) {
	  		component._renderedChildren.forEach(function (child) {
	  			visitor(child);
	  			if (!child._component) visitNonCompositeChildren(child, visitor);
	  		});
	  	}
	  }
	
	  /**
	   * Create a bridge between the preact component tree and React's dev tools
	   * and register it.
	   *
	   * After this function is called, the React Dev Tools should be able to detect
	   * "React" on the page and show the component tree.
	   *
	   * This function hooks into preact VNode creation in order to expose functional
	   * components correctly, so it should be called before the root component(s)
	   * are rendered.
	   *
	   * Returns a cleanup function which unregisters the hooks.
	   */
	
	  function initDevTools() {
	  	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	  		// React DevTools are not installed
	  		return;
	  	}
	
	  	// Hook into preact element creation in order to wrap functional components
	  	// with stateful ones in order to make them visible in the devtools
	  	var nextVNode = preact.options.vnode;
	  	preact.options.vnode = function (vnode) {
	  		if (isFunctionalComponent(vnode)) wrapFunctionalComponent(vnode);
	  		if (nextVNode) return nextVNode(vnode);
	  	};
	
	  	// Notify devtools when preact components are mounted, updated or unmounted
	  	var bridge = createDevToolsBridge();
	
	  	var nextAfterMount = preact.options.afterMount;
	  	preact.options.afterMount = function (component) {
	  		bridge.componentAdded(component);
	  		if (nextAfterMount) nextAfterMount(component);
	  	};
	
	  	var nextAfterUpdate = preact.options.afterUpdate;
	  	preact.options.afterUpdate = function (component) {
	  		bridge.componentUpdated(component);
	  		if (nextAfterUpdate) nextAfterUpdate(component);
	  	};
	
	  	var nextBeforeUnmount = preact.options.beforeUnmount;
	  	preact.options.beforeUnmount = function (component) {
	  		bridge.componentRemoved(component);
	  		if (nextBeforeUnmount) nextBeforeUnmount(component);
	  	};
	
	  	// Notify devtools about this instance of "React"
	  	__REACT_DEVTOOLS_GLOBAL_HOOK__.inject(bridge);
	
	  	return function () {
	  		preact.options.afterMount = nextAfterMount;
	  		preact.options.afterUpdate = nextAfterUpdate;
	  		preact.options.beforeUnmount = nextBeforeUnmount;
	  	};
	  }
	
	  initDevTools();
	
	}));
	//# sourceMappingURL=devtools.js.map


/***/ }
]);


// WEBPACK FOOTER //
// embed.js